export default __webpack_public_path__ + "static/media/68t.72ae5137.jpg";